module.exports = __webpack_public_path__ + "img/icon-twitter.454f3cb5.svg";